/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Button,
} from '@material-ui/core'
import { getActivitiesByForm } from '../../../../../services/Elegibilidad/get'
import { updateActivity } from '../../../../../services/Elegibilidad/put'
import swal from 'sweetalert'
import { insertActivity } from '../../../../../services/Elegibilidad/create'
import { deleteActivity } from '../../../../../services/Elegibilidad/delete'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'

// import { useFormik } from 'formik'
// import * as Yup from 'yup'

const Table391 = ({ idElegibilityForm, formik }) => {
  const [state, dispatch] = useEligibility()

  const [tableData, setTableData] = useState([])
  const [addOther, setAddOher] = useState(true)

  let optionValue = null

  const handleGuardar = async (data) => {
    const body = {
      IdProductiveActivityPlanning: 0,
      IdElegibilityAnswer: idElegibilityForm,
      IdActivity: 1,
      ActivityDetail: data.ActivityDetail,
      IdOption: optionValue,
      IsDefault: false,
    }

    const response = await insertActivity(body)
    if (response.Success) {
      swal({
        title: '¡Datos Agregados exitosamente!',
        icon: 'success',
      })
      getDataTable()

      optionValue = null
    }
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const getDataTable = async () => {
    try {
      const response = await getActivitiesByForm(idElegibilityForm)
      if (response.Success) {
        setTableData(response.Data)
        const result = response.Data.filter((obj) => obj.IdActivity === 1)
        const resultValidate = response.Data.filter(
          (obj) => obj.IdOption === null,
        )
        if (resultValidate.length === 0)
          formik.setFieldValue('validTable391', true)
        else {
          formik.setFieldValue('validTable391', false)
        }

        if (result.length === 0) setAddOher(true)
        else {
          setAddOher(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const handleActualizar = async (data) => {
    const body = {
      IdProductiveActivityPlanning: data.IdProductiveActivityPlanning,
      IdElegibilityAnswer: data.IdElegibilityAnswer,
      IdActivity: data.IdActivity,
      ActivityDetail: data.ActivityDetail,
      IdOption: optionValue,
      IsDefault: data.IsDefault,
    }
    const response = await updateActivity(body)
    if (response.Success) {
      getDataTable()
      optionValue = null
    }
  }

  const handleDelete = async (id) => {
    try {
      await deleteActivity(id)
      getDataTable()
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    // {
    //   title: 'Código',
    //   field: 'IdProductiveActivityPlanning',
    //   sorting: true,
    //   filtering: false,
    //   cellStyle: { c },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Actividad climática',
      field: 'ActivityDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
      validate: (rowData) =>
        rowData.ActivityDetail === '' ||
        rowData.ActivityDetail === null ||
        rowData.ActivityDetail === undefined ||
        (rowData.IdActivity === undefined &&
          rowData.ActivityDetail?.length > 100)
          ? {
              isValid: false,
              helperText: 'Este campo es obligatorio (máximo 100 caracteres)',
            }
          : true,
    },
    {
      title: 'Frecuencia',
      field: 'opc',
      sorting: false,
      filtering: false,

      editComponent: (rowData) => {
        return (
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            row
            onChange={(e) => {
              optionValue = e.target.value
            }}
            defaultValue={rowData.rowData.IdOption}
          >
            <FormControlLabel value="NU" control={<Radio />} label="Nunca" />
            <FormControlLabel
              value="NM"
              control={<Radio />}
              label="Normalmente"
            />
            <FormControlLabel value="AM" control={<Radio />} label="A menudo" />
          </RadioGroup>
        )
      },

      render: (rowData) => (
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={rowData.IdOption}
          name="radio-buttons-group"
          row
        >
          <FormControlLabel
            value="NU"
            control={<Radio />}
            disabled
            label="Nunca"
          />
          <FormControlLabel
            value="NM"
            control={<Radio />}
            label="Normalmente"
            disabled
          />
          <FormControlLabel
            value="AM"
            control={<Radio />}
            label="A Menudo"
            disabled
          />
        </RadioGroup>
      ),
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            actions={[
              !addOther
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                        disabled
                      >
                        Agregar actividad
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                  }
                : null,
            ]}
            editable={{
              isDeleteHidden: (rowData) => rowData.IdActivity !== 1,
              onRowAdd: addOther
                ? (newRow) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        if (
                          newRow.ActivityDetail === undefined ||
                          optionValue === null
                        ) {
                          alertValidationFields()
                        } else {
                          handleGuardar(newRow)
                        }
                        resolve()
                      }, 500)
                    })
                : null,
              onRowUpdate: (newData, oldData, rowData) =>
                new Promise((resolve, reject) => {
                  if (optionValue !== null) {
                    handleActualizar(oldData)
                  }
                  setTimeout(() => resolve(), 500)
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  handleDelete(oldData.IdProductiveActivityPlanning)
                  setTimeout(() => resolve(), 500)
                }),
            }}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              columnsButton: false,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Add: () => (
                <Button
                  variant="contained"
                  color="success"
                  style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                  startIcon={<AddIcon style={{ color: 'white' }} />}
                >
                  Agregar actividad
                </Button>
              ),
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table391)
